import { userHasRole } from "@accredo/fe-shared/utils/policyUtils.js";

export default {
  viewAny: ({ user }) => userHasRole(user, ["sysadmin"]),
  view:    ({ user }) => userHasRole(user, ["sysadmin"]),
  create:  ({ user }) => userHasRole(user, ["sysadmin"]),
  update:  ({ user }) => userHasRole(user, ["sysadmin"]),
  delete:  ({ user }) => userHasRole(user, ["sysadmin"]),
  reapply: ({ user }) => userHasRole(user, ["sysadmin"]),
};
